import { SwapStatus } from '@layerswap/widget-types';
import { BackendTransactionStatus, TransactionType } from '../lib/apiClients/layerSwapApiClient';
import { isGaslessAuthorizationSubmitted, isGaslessDepositWorkflow } from './gasless';
const ADVANCED_SWAP_STATUSES = new Set([
    SwapStatus.LsTransferPending,
    SwapStatus.Completed,
    SwapStatus.PendingRefund,
    SwapStatus.Refunded,
]);
/** Only fetched swap, workflow and authorization data describe execution progress. */
export function hasSwapExecutionProgress({ swapDetails, depositActions, gaslessAuthorization }) {
    if (swapDetails?.status && ADVANCED_SWAP_STATUSES.has(swapDetails.status))
        return true;
    if (swapDetails?.transactions?.some(transaction => transaction.type === TransactionType.Input
        && transaction.status !== BackendTransactionStatus.Failed && !!transaction.transaction_hash))
        return true;
    if (isGaslessAuthorizationSubmitted(gaslessAuthorization))
        return true;
    const authorizationFailed = gaslessAuthorization?.status === 'expired'
        || gaslessAuthorization?.status === 'insufficient' || gaslessAuthorization?.status === 'rejected';
    const selfPaid = isGaslessDepositWorkflow(depositActions) === false;
    const firstIncompleteIndex = depositActions?.findIndex(action => action.status !== 'completed') ?? -1;
    return depositActions?.some((action, index) => {
        if (action.status !== 'pending' && action.status !== 'completed')
            return false;
        if (action.status === 'pending' && index !== firstIncompleteIndex)
            return false;
        if (action.step === 'publish' || action.step === 'deposit')
            return true;
        return action.step === 'sign' && !selfPaid && !authorizationFailed;
    }) ?? false;
}
/** Deduplicate recorded wallet actions until fetched data proves they cannot move funds. */
export function hasUnacknowledgedWalletAction(input) {
    if (input.pendingSubmission)
        return true;
    if (input.transaction?.kind === 'atomic-batch' && input.transaction.atomicBatchFailure)
        return false;
    if (input.transaction?.providerSubmissionAccepted)
        return true;
    if (input.transaction?.hash && !(input.transactionStatus?.hash === input.transaction.hash
        && input.transactionStatus.status === 'failed'))
        return true;
    const authorization = input.gaslessAuthorization;
    const failed = authorization?.status === 'expired' || authorization?.status === 'insufficient'
        || authorization?.status === 'rejected';
    if (authorization?.transaction?.transaction_hash && authorization.transaction.status !== 'failed')
        return true;
    if (failed || isGaslessDepositWorkflow(input.depositActions) === false)
        return false;
    return !!input.authorizationReceipt || !!input.signatureReceipt;
}
